<!--Mobile Header-->
<fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/'"></fgb-page-header>
<!--Sub Nav-->
<div class="container">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<div class="container mt-3">
  <fgbcl-marketplace-list
    [isList]="true"
    [marketplaceItemView]="true"
    [marketplaceItemTypes]="[3, 5]"
    [defaultSort]="2"
  ></fgbcl-marketplace-list>
</div>
